import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledDropdown = styled('div')`
  width: ${(props) => props.width};
  .dropdown-container {
    display: flex;
    width: ${(props) => props.metaData?.width};
    align-items: center;
    justify-content: space-between;
    gap: ${(props) => props.metaData?.gap};
    padding: ${(props) => props.metaData?.padding};
    border: ${(props) => props.metaData?.border};
    border-radius: 8px;
    cursor: pointer;
    height: ${(props) => props.metaData?.height};
    box-sizing: border-box;
    background-color: ${(props) =>
      props.isSelectingOption && props.metaData?.backgroundColor};

    &:hover {
      background-color: ${COLOR.backgroundLinearProgress};
    }
    .dropdown-title {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &.disabled {
      pointer-events: auto;
      cursor: not-allowed !important;
      opacity: 0.5;
    }
    @media (max-width: 1170px) {
      width: 100%;
    }
  }
`;

export const StyledListMenuItem = styled('div')`
  padding: ${(props) => props.metaData?.paddingListMenuItemHover || '8px'};
  padding-top: ${(props) => props.searchable && '0px'};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.metaData?.boxShadown || '0px 4px 16px 0px #00000014'};
  height: ${(props) =>
    props.overflow ? props.metaData?.maxHeightList : 'auto'};
  overflow-y: auto;

  &.scrollbar-custom {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
  }
  &.hidden-scrollbar {
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }
  }
`;

export const PopoverMenuItem = styled('div')`
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && '#1E164E14'};
  display: flex;
  gap: 10px;
  margin-bottom: ${(props) => props.metaData?.marginBottom || '0px'};
  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? '#1E164E14' : TRANSPARENT_COLOR.dark};
  }
  &.disabled {
    pointer-events: auto;
    cursor: not-allowed !important;
    opacity: 0.5;
  }
`;
